// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__2JT1E","savePackageButton":"ClientWallet_savePackageButton__2q54h"};